import React from 'react'

export default function TabelaReferenciaIndicadores() {

    const linhas = [

        {
            indicador: 'Geração por FTE',
            infectantes: 'kg/FTE',
            quimicos: 'kg/FTE',
            perfurocortantes: 'kg/FTE',
            reciclaveis: 'kg/FTE',
            naoReciclaveis: 'kg/FTE',
            total: 'kg/FTE'
        },

        {
            indicador: 'Geração por leito',
            infectantes: 'kg/leito',
            quimicos: 'kg/leito',
            perfurocortantes: 'kg/leito',
            reciclaveis: 'kg/leito',
            naoReciclaveis: 'kg/leito',
            total: 'kg/leito'
        },

        {
            indicador: 'Geração por sala cirúrgica',
            infectantes: 'kg/sala',
            quimicos: 'kg/sala',
            perfurocortantes: 'kg/sala',
            reciclaveis: 'kg/sala',
            naoReciclaveis: 'kg/sala',
            total: 'kg/sala'
        },

        {
            indicador: 'Geração por área',
            infectantes: 'kg/m²',
            quimicos: 'kg/m²',
            perfurocortantes: 'kg/m²',
            reciclaveis: 'kg/m²',
            naoReciclaveis: 'kg/m²',
            total: 'kg/m²'
        },

        {
            indicador: 'Participação no total de resíduos',
            infectantes: '%',
            quimicos: '%',
            perfurocortantes: '%',
            reciclaveis: '%',
            naoReciclaveis: '%',
            total: '100%'
        }

    ]


    const thStyle = {
        backgroundColor: '#24557F',
        color: '#ffffff',
        textAlign: 'center',
        verticalAlign: 'middle',
        fontWeight: '600',
        fontSize: '13px',
        padding: '10px 8px',
        whiteSpace: 'nowrap'
    }


    const tdStyle = {
        textAlign: 'center',
        verticalAlign: 'middle',
        fontSize: '13px',
        padding: '9px 8px'
    }


    const indicadorStyle = {
        ...tdStyle,
        textAlign: 'left',
        fontWeight: '600',
        backgroundColor: '#dcecf7',
        color: '#333'
    }


    return (

        <div
            style={{
                marginTop: '25px',
                marginBottom: '25px'
            }}
        >

            {/* =====================================================
                TÍTULO
               ===================================================== */}

            <div
                style={{
                    marginBottom: '14px'
                }}
            >

                <h4
                    style={{
                        margin: 0,
                        fontWeight: '600',
                        color: '#2f9b4b'
                    }}
                >
                    Referência de indicadores base PHS
                </h4>

                <div
                    style={{
                        fontSize: '13px',
                        color: '#777',
                        marginTop: '4px'
                    }}
                >
                    Unidades de referência dos indicadores de geração
                    de resíduos
                </div>

            </div>


            {/* =====================================================
                CARD
               ===================================================== */}

            <div
                style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #d7dce1',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}
            >

                <div
                    style={{
                        overflowX: 'auto'
                    }}
                >

                    <table
                        className="table table-bordered"
                        style={{
                            marginBottom: 0,
                            minWidth: '950px'
                        }}
                    >

                        <thead>

                            <tr>

                                <th style={thStyle}>
                                    Indicador de referência PHS
                                </th>

                                <th style={thStyle}>
                                    Infectantes
                                </th>

                                <th style={thStyle}>
                                    Químicos
                                </th>

                                <th style={thStyle}>
                                    Perfurocortantes
                                </th>

                                <th style={thStyle}>
                                    Recicláveis
                                </th>

                                <th style={thStyle}>
                                    Não recicláveis
                                </th>

                                <th style={thStyle}>
                                    Resíduos totais
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {linhas.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <tr key={index}>

                                        <td
                                            style={
                                                indicadorStyle
                                            }
                                        >
                                            {
                                                item.indicador
                                            }
                                        </td>

                                        <td style={tdStyle}>
                                            {
                                                item.infectantes
                                            }
                                        </td>

                                        <td style={tdStyle}>
                                            {
                                                item.quimicos
                                            }
                                        </td>

                                        <td style={tdStyle}>
                                            {
                                                item.perfurocortantes
                                            }
                                        </td>

                                        <td style={tdStyle}>
                                            {
                                                item.reciclaveis
                                            }
                                        </td>

                                        <td style={tdStyle}>
                                            {
                                                item.naoReciclaveis
                                            }
                                        </td>

                                        <td
                                            style={{
                                                ...tdStyle,
                                                fontWeight:
                                                    item.indicador ===
                                                    'Participação no total de resíduos'
                                                        ? '700'
                                                        : 'normal'
                                            }}
                                        >
                                            {
                                                item.total
                                            }
                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    )

}